import { render, staticRenderFns } from "./ShowAddVolunteer.vue?vue&type=template&id=5bfa89ea&scoped=true&lang=pug&"
import script from "./ShowAddVolunteer.vue?vue&type=script&lang=js&"
export * from "./ShowAddVolunteer.vue?vue&type=script&lang=js&"
import style0 from "./ShowAddVolunteer.vue?vue&type=style&index=0&id=5bfa89ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfa89ea",
  null
  
)

export default component.exports